import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { queries } from "../../Infrastructure/const/queries";

export const userAPI = createApi({
    reducerPath: 'userAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: queries.baseURL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('userToken');

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
                headers.set('Accept', `application/json`);
            }
            return headers;
        }
    }),

    // ✅ Добавляем типы тегов
    tagTypes: ['Users'],

    endpoints: (build) => ({

        // 🔹 Авторизация
        loginUser: build.mutation({
            query: (body) => ({
                url: queries.login,
                method: 'POST',
                body
            })
        }),

        register: build.mutation({
            query: (body) => ({
                url: 'auth/register',
                method: 'POST',
                body
            })
        }),

        // 🔹 Получение текущего пользователя
        fetchMe: build.query({
            query: () => ({
                url: queries.me,
                method: 'GET',
            })
        }),

        // 🔹 Выход из системы
        logoutUser: build.mutation({
            query: () => ({
                url: queries.logout,
                method: 'POST'
            })
        }),

        // 🔹 Получение всех пользователей
        fetchUsers: build.query({
            query: () => ({
                url: 'users',
                method: 'GET'
            }),
            providesTags: ['Users'], // 👈 этот запрос зависит от Users
        }),

        // 🔹 Создание пользователя
        createUser: build.mutation({
            query: (body) => ({
                url: 'users',
                method: 'POST',
                body
            }),
            invalidatesTags: ['Users'], // 👈 после создания обновляем список
        }),

        // 🔹 Обновление пользователя
        updateUser: build.mutation({
            query: ({ id, body }) => ({
                url: `users/${id}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ['Users'], // 👈 обновляем список после редактирования
        }),

        // 🔹 Получение конкретного пользователя
        fetchUserById: build.query({
            query: (id) => ({
                url: `users/${id}`,
                method: 'GET',
            }),
            providesTags: ['Users'], // 👈 также зависит от Users
        }),

        // 🔹 Удаление пользователя (если появится)
        deleteUser: build.mutation({
            query: (id) => ({
                url: `users/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Users'], // 👈 обновляем список после удаления
        }),

        assignCategory: build.mutation({
            query: ({id, body}) => ({
                url: `users/${id}/assign-categories`,
                method: 'POST',
                body
            })
        }),

        removeCategory: build.mutation({
            query: (id) => ({
                url: `users/${id}/remove-category`,
                method: 'POST',

            })
        }),

        changePassword: build.mutation({
            query: (body) => ({
                url: 'auth/change-password',
                method: 'POST',
                body
            })
        })
    })
});
